import React from "react";
import {
  Checkbox,
  Card,
  Space,
  Tag,
  Typography,
  Alert,
  Button,
  Row,
  Col,
  Tooltip,
} from "antd";
import { UserOutlined, PlusOutlined, LockOutlined } from "@ant-design/icons";

const { Text } = Typography;

const DefendantCheckboxGroup = ({
  tabNumber,
  defendants,
  selectedValues,
  onChange,
  customerCustomerId,
  onAddClick,
  onRemoveCustom,
  loading,
  disabledDefendants = [], // ✅ เพิ่ม prop
}) => {
  const isTab1 = tabNumber === 1;

  const handleChange = (checkedIds) => {
    const selectedObjects = defendants.filter((defendant) =>
      checkedIds.includes(defendant.CUSTOMER_ID),
    );

    console.log("📋 Selected IDs:", checkedIds);
    console.log("📦 Selected Objects:", selectedObjects);

    onChange(checkedIds, selectedObjects);
  };

  if (loading) {
    return (
      <Alert
        message="กำลังโหลดข้อมูลจำเลย..."
        type="info"
        showIcon
        style={{ maxWidth: 400 }}
      />
    );
  }

  if (!defendants || defendants.length === 0) {
    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          message={isTab1 ? "ไม่พบข้อมูลจำเลย" : "ไม่มีผู้ค้ำประกันในสัญญานี้"}
          type="info"
          showIcon
          style={{ maxWidth: 400 }}
        />
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          onClick={onAddClick}
          style={{ width: "100%", height: 48 }}
          size="large"
        >
          เพิ่มจำเลย
        </Button>
      </Space>
    );
  }

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Checkbox.Group
        value={selectedValues}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {defendants.map((person) => {
            const isCustomer = person.type === "customer";
            const isCustom = person.type === "custom";
            const isChecked = selectedValues.includes(person.CUSTOMER_ID);

            // ✅ ตรวจสอบว่าถูก disabled จาก Tab อื่นหรือไม่
            const isDisabledByOtherTab = disabledDefendants.includes(
              person.CUSTOMER_ID,
            );

            // ✅ disabled ถ้าเป็น customer ใน Tab1 หรือถูกเลือกใน Tab อื่นแล้ว
            const isDisabled = (isTab1 && isCustomer) || isDisabledByOtherTab;

            return (
              <Tooltip
                key={person.CUSTOMER_ID}
                title={
                  isDisabledByOtherTab
                    ? `ถูกเลือกใน Tab ${isTab1 ? "2" : "1"} แล้ว`
                    : ""
                }
                placement="left"
              >
                <Card
                  size="small"
                  style={{
                    borderRadius: 8,
                    border: isChecked
                      ? "2px solid #1890ff"
                      : isDisabledByOtherTab
                        ? "1px solid #ff4d4f"
                        : "1px solid #d9d9d9",
                    background: isChecked
                      ? "#e6f7ff"
                      : isDisabledByOtherTab
                        ? "#fff1f0"
                        : "#fff",
                    transition: "all 0.3s",
                    opacity: isDisabledByOtherTab ? 0.6 : 1,
                  }}
                >
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Checkbox
                        value={person.CUSTOMER_ID}
                        disabled={isDisabled}
                      >
                        <Space size="middle" wrap>
                          <Tag
                            color={
                              isDisabledByOtherTab
                                ? "red"
                                : isCustomer
                                  ? "blue"
                                  : isCustom
                                    ? "purple"
                                    : "green"
                            }
                            icon={
                              isDisabledByOtherTab ? (
                                <LockOutlined />
                              ) : (
                                <UserOutlined />
                              )
                            }
                          >
                            {isDisabledByOtherTab
                              ? `เลือกแล้ว (ในคำพิพากษา${isTab1 ? "ถัดไป" : "ที่ 1"})`
                              : person.typeLabel}
                          </Tag>
                          <Text
                            strong
                            style={{
                              fontSize: 15,
                              textDecoration: isDisabledByOtherTab
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {person.SNAM}
                            {person.NAME1} {person.NAME2}
                          </Text>
                          {person.RELATN && (
                            <Tag color="orange">{person.RELATN}</Tag>
                          )}
                        </Space>
                      </Checkbox>
                    </Col>
                  </Row>
                </Card>
              </Tooltip>
            );
          })}
        </Space>
      </Checkbox.Group>

      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={onAddClick}
        style={{ width: "100%", height: 48 }}
        size="large"
      >
        เพิ่มจำเลย
      </Button>
    </Space>
  );
};

export default DefendantCheckboxGroup;
